import { createRouter, createWebHistory } from 'vue-router';
import Store from '@/store/index';

//页面
import Home from '@/views/Home.vue';  //首页
import Index from '@/views/Index.vue';  //首页
import Login from '@/views/Login.vue';  //登录页
import NotFound from '@/views/404.vue';  //404页面
import Main from '@/views/Main.vue'; //主页
import OperationManage from '@/views/OperationManage.vue';  //运营管理
import OrganManage from '@/views/OrganManage.vue';  //组织管理
import UserList from '@/views/UserList.vue';  //用户管理
import RoleList from '@/views/RoleList.vue';  //角色管理
import TenantManage from '@/views/TenantManage.vue';  //租户管理
import Enterprise from '@/views/Enterprise.vue';  //企业账号管理
import Personal from '@/views/Personal.vue';  //个人账号管理
import VehicleManage from '@/views/VehicleManage.vue';  //车辆管理
import LimitsManage from '@/views/LimitsManage.vue';  //权限管理
import EquipmentManage from '@/views/EquipmentManage.vue';  //设备管理
import Manufacturer from '@/views/Manufacturer.vue';  //生产商管理
import StationManage from '@/views/StationManage.vue';  //场站管理
import ChargePileList from '@/views/ChargePileList.vue';  //充电桩管理
import ChargeGunList from '@/views/ChargeGunList.vue';  //充电枪管理
import PartnerManage from '@/views/PartnerManage.vue';  //分成方管理
import SplitTemplate from '@/views/SplitTemplate.vue';  //分成模板管理
import SetSplitTemplate from '@/views/SetSplitTemplate.vue';  //分成模板配置
import ElectricityCost from '@/views/ElectricityCost.vue';  //电费成本模板
import SetElectricityCost from '@/views/SetElectricityCost.vue';  //电费成本模板配置
import ChargeTemplate from '@/views/ChargeTemplate.vue';  //充电计费模板管理
import SetTemplate from '@/views/SetTemplate.vue';  //充电计费模板配置
import ChargeUserList from '@/views/ChargeUserList.vue';  //充电用户管理
import UserGroupManage from '@/views/UserGroupManage.vue';  //用户组管理
import ChargeOrderList from '@/views/ChargeOrderList.vue';  //充电订单管理
import ParkCouponList from '@/views/ParkCouponList.vue';  //停车优惠券管理
import ThirdPark from '@/views/ThirdPark.vue';  //第三方停车配置
import Finance from '@/views/Finance.vue';  //财务管理
import CashFlow from '@/views/CashFlow.vue';  //现金流水管理
import InvoiceStatistics from '@/views/InvoiceStatistics.vue';  //发票统计管理
import MerchantSettlement from '@/views/MerchantSettlement.vue';  //商户结算单管理
import TicketManage from '@/views/TicketManage.vue';  //税票管理
import OrderManagement from '@/views/OrderManagement.vue';  //订单管理
import NoFeeOrderManage from '@/views/NoFeeOrderManage.vue';  //未扣费订单管理
import CouponManage from '@/views/CouponManage.vue';  //优惠券管理
import AccountDiscount from '@/views/AccountDiscount.vue';  //账号折扣管理
import AccountCoupon from '@/views/AccountCoupon.vue';  //账号优惠券管理
import ActivityManagement from '@/views/ActivityManagement.vue';  //活动管理
import ExchangeCoupon from '@/views/ExchangeCoupon.vue';  //兑换券管理
import AlarmManagement from '@/views/AlarmManagement.vue';  //告警管理
import BannerManage from '@/views/BannerManage.vue';  //轮播图管理
import QrcodeConfig from '@/views/QrcodeConfig.vue';  //二维码规则配置
import HlhtConfig from '@/views/HlhtConfig.vue';  //互联互通配置
import ReceivableChannels from '@/views/ReceivableChannels.vue';  //收款渠道管理
import AppManagement from '@/views/AppManagement.vue';  //客户端信息管理
import ThirdAppManagement from '@/views/ThirdAppManagement.vue';  //第三方应用管理
import ThirdAppDetail from '@/views/ThirdAppDetail.vue';  //第三方应用详情
import ChargeRecord from '@/views/ChargeRecord.vue';  //充电记录表
import ReportManagement from '@/views/ReportManagement.vue';  //报表管理
import PeriodicData from '@/views/PeriodicData.vue';  //周期数据管理
import StationData from '@/views/StationData.vue';  //场站数据管理
import LargeScreen from '@/views/LargeScreen.vue';  //大屏管理
 
//路由配置
var routerList = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name:'Login',
    component: Login
  },
  {
    path: "/largescreen",
    name:'LargeScreen',
    component: LargeScreen
  },
  {
    path: "/home",
    component: Home,
    redirect:'/index',
    children: []
  },
  {
    path: "/main",
    component: Home,
    children: [
      {
        path: "",
        name:'Main',
        children: [],
        component: Main
      },
    ]
  },
  {
    path: "/index",
    component: Home,
    children: [
      {
        path: "",
        name: 'Index',  // 添加name属性，与组件name一致
        component: Index
      },
    ]
  },
  {
    path: "/op",
    component: Home,
    children: [
      {
        path: "",
        name:'OperationManage',
        component: OperationManage,
        children: []
      },
      {
        path: "chargetemplate",
        name:'ChargeTemplate',
        children: [],
        component: ChargeTemplate
      },
      {
        path: "settemplate",
        name:'SetTemplate',
        children: [],
        component: SetTemplate
      },
      {
        path: "chargeuserlist",
        name:'ChargeUserList',
        children: [],
        component: ChargeUserList
      },
      {
        path: "usergroup",
        name:'用户组管理',
        children: [],
        component: UserGroupManage
      },
      {
        path: "chargeorderlist",
        name:'ChargeOrderList',
        children: [],
        component: ChargeOrderList
      },
      {
        path: "parkcouponlist",
        name:'ParkCouponList',
        children: [],
        component: ParkCouponList
      },
      {
        path: "thirdpark",
        name:'ThirdPark',
        children: [],
        component: ThirdPark
      },
    ]
  },
  {
    path: "/finance",
    component: Home,
    children: [
      {
        path: "",
        name:'Finance',
        component: Finance,
        children: []
      },
      {
        path: "cashflow",
        name:'CashFlow',
        component: CashFlow,
        children: []
      },
      {
        path: "invoicestatistics",
        name:'InvoiceStatistics',
        component: InvoiceStatistics,
        children: []
      },
      {
        path: "merchantsettlement",
        name:'MerchantSettlement',
        component: MerchantSettlement,
        children: []
      },
      {
        path: "ticketmanage",
        name:'TicketManage',
        component: TicketManage,
        children: []
      },
      {
        path: "receivablechannels",
        name:'ReceivableChannels',
        component: ReceivableChannels,
        children: []
      },
    ]
  },
  {
    path: "/em",
    component: Home,
    children: [
      {
        path: "",
        name:'EquipmentManage',
        children: [],
        component: EquipmentManage
      },
      {
        path: "stationmanage",
        name:'StationManage',
        children: [],
        component: StationManage
      },
      {
        path: "chargepilelist",
        name:'ChargePileList',
        children: [],
        component: ChargePileList
      },
      {
        path: "chargegunlist",
        name:'ChargeGunList',
        children: [],
        component: ChargeGunList
      },
      {
        path: "manufacturer",
        name:'Manufacturer',
        children: [],
        component: Manufacturer
      },
      {
        path: "partnermanage",
        name:'PartnerManage',
        children: [],
        component: PartnerManage
      },
      {
        path: "splittemplate",
        name:'SplitTemplate',
        children: [],
        component: SplitTemplate
      },
      {
        path: "setsplittemplate",
        name:'SetSplitTemplate',
        children: [],
        component: SetSplitTemplate
      },
      {
        path: "electricitycost",
        name:'ElectricityCost',
        children: [],
        component: ElectricityCost
      },
      {
        path: "setelectricitycost",
        name:'SetElectricityCost',
        children: [],
        component: SetElectricityCost
      },
    ]
  },
  {
    path: "/accountdiscount",
    component: Home,
    children: [
      {
        path: "",
        name:'AccountDiscount',
        children: [],
        component: AccountDiscount
      },
    ]
  },
  {
    path: "/accountcoupon",
    component: Home,
    children: [
      {
        path: "",
        name:'AccountCoupon',
        children: [],
        component: AccountCoupon
      },
    ]
  },
  {
    path: "/activitymanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'ActivityManagement',
        children: [],
        component: ActivityManagement
      },
    ]
  },
  {
    path: "/exchangecoupon",
    component: Home,
    children: [
      {
        path: "",
        name:'ExchangeCoupon',
        children: [],
        component: ExchangeCoupon
      },
    ]
  },
  {
    path: "/qrcodeconfig",
    component: Home,
    children: [
      {
        path: "",
        name:'QrcodeConfig',
        children: [],
        component: QrcodeConfig
      },
    ]
  },
  {
    path: "/hlhtconfig",
    component: Home,
    children: [
      {
        path: "",
        name:'HlhtConfig',
        children: [],
        component: HlhtConfig
      },
    ]
  },
  {
    path: "/alarmmanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'AlarmManagement',
        children: [],
        component: AlarmManagement
      },
    ]
  },
  {
    path: "/bannermanage",
    component: Home,
    children: [
      {
        path: "",
        name:'BannerManage',
        children: [],
        component: BannerManage
      },
    ]
  },
  {
    path: "/appmanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'AppManagement',
        children: [],
        component: AppManagement
      },
    ]
  },
  {
    path: "/thirdappmanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'ThirdAppManagement',
        children: [],
        component: ThirdAppManagement
      },
      {
        path: "detail/:appKey",
        name:'ThirdAppDetail',
        children: [],
        component: ThirdAppDetail
      },
    ]
  },
  {
    path: "/chargerecord",
    component: Home,
    children: [
      {
        path: "",
        name:'ChargeRecord',
        children: [],
        component: ChargeRecord
      },
    ]
  },
  {
    path: "/reportmanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'ReportManagement',
        children: [],
        component: ReportManagement
      },
    ]
  },
  {
    path: "/periodicdata",
    component: Home,
    children: [
      {
        path: "",
        name:'PeriodicData',
        children: [],
        component: PeriodicData
      },
    ]
  },
  {
    path: "/stationdata",
    component: Home,
    children: [
      {
        path: "",
        name:'StationData',
        children: [],
        component: StationData
      },
    ]
  },
  {
    path: "/ordermanagement",
    component: Home,
    children: [
      {
        path: "",
        name:'OrderManagement',
        children: [],
        component: OrderManagement
      },
    ]
  },
  {
    path: "/nofeeordermanage",
    component: Home,
    children: [
      {
        path: "",
        name:'NoFeeOrderManage',
        children: [],
        component: NoFeeOrderManage
      },
    ]
  },
  {
    path: "/tenantmanage",
    component: Home,
    children: [
      {
        path: "",
        name:'TenantManage',
        children: [],
        component: TenantManage
      },
    ]
  },
  {
    path: "/enterprise",
    component: Home,
    children: [
      {
        path: "",
        name:'Enterprise',
        children: [],
        component: Enterprise
      },
    ]
  },
  {
    path: "/personal",
    component: Home,
    children: [
      {
        path: "",
        name:'Personal',
        children: [],
        component: Personal
      },
    ]
  },
  {
    path: "/vehiclemanage",
    component: Home,
    children: [
      {
        path: "",
        name:'VehicleManage',
        children: [],
        component: VehicleManage
      },
    ]
  },
  {
    path: "/couponmanage",
    component: Home,
    children: [
      {
        path: "",
        name:'CouponManage',
        children: [],
        component: CouponManage
      },
    ]
  },
  
  {
    path: "/userlist",
    // name:'用户管理',
    component: Home,
    children: [
      {
        path: "",
        name:'UserList',
        children: [],
        component: UserList
      },
      {
        path: "organmanage",
        name:'OrganManage',
        children: [],
        component: OrganManage
      },
      {
        path: "rolelist",
        name:'RoleList',
        children: [],
        component: RoleList
      },
      {
        path: "limitsmanage",
        children: [],
        name:'LimitsManage',
        component: LimitsManage
      },
    ]
  },
  // 新的404路由写法
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: Home,
    children: [
      {
        path: "",
        name:'404页面',
        children: [],
        component: NotFound
      },
    ]
  }
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory('/'),
  routes:routerList,
  // routes: [
  //   { path: '/', component: Login },
  //   { path: '/home', component: Home },
  // ],
});

//code_data 权限菜单编码
//router_data 路由菜单
router.filterRouter = function(code_data){
  const realRouter = [];

  // console.log(code_data);
  // router_data.forEach((v)=>{
  //   if(v.isShow && v.meta){
  //     console.log(v.meta.roleCode);
  //     if(v.meta.roleCode == 'all'){
  //       realRouter.push(v);
  //     }else if(code_data.includes(v.meta.roleCode)){
  //       realRouter.push(v);
  //     }
  //   }
    
    // code_data.forEach(item=>{
    //   if(v.meta){
    //     if(item === v.meta.roleCode){
    //       if(v.children && v.children.length>0){
    //         v.children = router.filterRouter(code_data,v.children);
    //       }
    //     }
    //   }
    // })
  // })
  router.options.routes = realRouter;
  return realRouter;
}

//路由守卫
router.beforeEach((to, from, next) => {
  next();
  // if(to.path == "/" && Store.state.token!=""){
  //   //已登录
  //   next('/home')
  // }else{
    // console.log('To Path:', to.path);
 	// if(store.state.root == "all"){
	// 	document.title = to.meta.title; //设置标题名称
	// 	versionTood.isNewVersion();
	// 	next();
	// }
	//  else{
	// 	if(to.path == "/" || to.path == "/home"){
	// 		document.title = to.meta.title; //设置标题名称
	// 		versionTood.isNewVersion();
	// 		next();
	// 	}
	// 	else if(store.state.auth.includes(to.path)){
	// 		document.title = to.meta.title; //设置标题名称
	// 		versionTood.isNewVersion();
	// 		next();
	// 	} else{
	// 		alert("没有权限")
	// 	}
	// }
});
 
export default router;